import type { ContentTypeEnum } from "scmp-app/queries/__generated__/searchArticleResultPaginationQuery.graphql";

export const DefaultPageSize = 20;
export const MaxKeywordLength = 256;
export const DefaultContentTypes: ContentTypeEnum[] = ["ARTICLE", "VIDEO", "GALLERY"];
